import * as React from "react";
import type { SVGProps } from "react";
const SvgUserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="user_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 896c99.328 0 189.867-37.717 258.005-99.584a266.795 266.795 0 0 0-516.01 0A382.592 382.592 0 0 0 512 896zm133.035-357.973A353.28 353.28 0 0 1 833.92 721.408a384 384 0 1 0-643.84 0 353.28 353.28 0 0 1 188.885-183.424 195.541 195.541 0 1 1 266.07 0zM981.333 512c0 120.192-45.184 229.845-119.466 312.875l-1.494 1.621-.981 1.067a472.107 472.107 0 0 1-83.115 72.362A467.2 467.2 0 0 1 512 981.333a467.2 467.2 0 0 1-271.701-86.613 471.979 471.979 0 0 1-78.166-69.803A467.584 467.584 0 0 1 42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512zM622.208 394.667a110.208 110.208 0 1 0-220.416 0 110.208 110.208 0 0 0 220.416 0z"
    />
  </svg>
);
export default SvgUserIcon;
